import { Container, Title, Stack, Text } from '@mantine/core';
import { AssetFieldSettings } from './components/AssetFieldSettings';

export function AssetFieldsPage() {
  return (
    <Container fluid>
      <Stack gap="lg">
        <div>
          <Title order={1}>Asset Field Settings</Title>
          <Text c="dimmed" size="sm">
            Configure which fields are shown and required when creating or editing assets
          </Text>
        </div>

        <AssetFieldSettings />
      </Stack>
    </Container>
  );
}
